import {create} from 'zustand';
import {DistanceSliderStore} from './types';

const useDistanceSliderStore = create<DistanceSliderStore>(set => ({
	distanceSlider: 25,
	setDistanceSlider: distance => set({distanceSlider: distance}),
}));

export {useDistanceSliderStore};
